module.exports = "<div style=\"text-align:center\">\n\n  <app-card-template [navlinks]=navLinks></app-card-template >\n  \n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/hkk/source/crazyaboutmath/src/app/menu-inaction/menu-inaction.component.html
// module id = ../../../../../src/app/menu-inaction/menu-inaction.component.html
// module chunks = main